import { render, staticRenderFns } from "./JobIndex.vue?vue&type=template&id=5d515e97&scoped=true"
import script from "./JobIndex.vue?vue&type=script&lang=js"
export * from "./JobIndex.vue?vue&type=script&lang=js"
import style0 from "./JobIndex.vue?vue&type=style&index=0&id=5d515e97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d515e97",
  null
  
)

export default component.exports